module.exports = __webpack_public_path__ + "images/help/video-newtodo-small-7e4a8d8aea7f02214cd2b1a1e9650ebc.png";